<template>
  <div>
    <!-- 个人意外伤害险投保须知 -->
    <h1>投保须知</h1>
    <h4>1、投保时被保险人的年龄应在16-65周岁（含）之间。</h4>
    <h4>2、本保险仅接受《紫金保险职业分类表》中1-3类职业人员投保，当被保险人的职业不在1-3类列表中时，不属于本保险责任范畴。</h4>
    <h4>3、被保险人从事潜水、跳伞、攀岩运动、探险活动、武术比赛、摔跤比赛、特技表演、赛马、赛车等高风险运动时，不属于本保险责任范畴。</h4>
    <h4>4、本保险意外事故的发生仅限在中华人民共和国境内（不含港、澳、台地区）。</h4>
    <h4>5、每次事故意外伤害医疗保险金在扣除100元后按照90%进行赔付。</h4>
    <h4>6、被保险人为未成年人的，其保险金额超出中国保监会最高保额限制的，赔付时按照中国保险监督管理委员会规定的未成年人最高保额限制赔付。</h4>
    <h4>7、其他未尽事宜以紫金财产保险股份有限公司《人身意外伤害保险条款(2018版)》、《附加人身意外伤害医疗保险条款》为准。</h4>
  </div>
</template>

<script>
export default {
  activated(){
    this.$store.commit('setShow',false)
  }
}
</script>

<style lang="scss" scoped>
  @import "./InstructionsForInsurance.scss"
</style>



// WEBPACK FOOTER //
// src/pages/car/InstructionsForInsurance/index.vue